module.exports = __webpack_public_path__ + "_assets/img/easyCard.07fed966.svg";